import { Component, inject } from '@angular/core';
import { LoaderService } from '../../services/loader.service';

/** Global overlay driven by LoaderService; mounted once in the root component. */
@Component({
  selector: 'app-loader',
  template: `
    @if (loader.visible()) {
      <div class="app-loader" role="status" aria-live="polite">
        <div class="app-loader__card">
          <span class="app-loader__spinner" aria-hidden="true"></span>
          <span>{{ loader.message() }}</span>
        </div>
      </div>
    }
  `,
  styles: `
    .app-loader {
      position: fixed;
      inset: 0;
      z-index: 2000;
      display: grid;
      place-items: center;
      background: rgb(15 23 42 / 0.25);
      backdrop-filter: blur(1.5px);
      animation: app-loader-in 0.15s ease 0.1s both;
    }
    .app-loader__card {
      display: flex;
      align-items: center;
      gap: 0.75rem;
      padding: 0.9rem 1.25rem;
      border-radius: 12px;
      background: var(--app-surface);
      color: var(--app-text);
      box-shadow: var(--app-shadow-lg);
      font-size: 0.9rem;
      font-weight: 500;
    }
    .app-loader__spinner {
      width: 22px;
      height: 22px;
      border-radius: 50%;
      border: 3px solid color-mix(in srgb, var(--app-primary) 20%, transparent);
      border-top-color: var(--app-primary);
      animation: app-spin 0.7s linear infinite;
    }
    @keyframes app-loader-in {
      from { opacity: 0; }
      to { opacity: 1; }
    }
  `,
})
export class LoaderComponent {
  protected readonly loader = inject(LoaderService);
}
